// podcasts.js — browser-side helpers for the Listen tab.
//
// Subscriptions live in preferences.podcast_feeds as an array of:
//   { id, url, title?, image?, color?, added_at }
//
// title/image are optimistically populated from the first feed-fetch so the
// list renders immediately without an extra round trip.

export async function fetchPodcastFeed(url) {
  if (!url) throw new Error("URL required");
  const r = await fetch(`/api/podcast-feed?url=${encodeURIComponent(url)}`);
  if (!r.ok) {
    let detail = `${r.status}`;
    try { const j = await r.json(); if (j?.error) detail = j.error; } catch {}
    throw new Error(detail);
  }
  return r.json();
}

export function newFeedRecord(url) {
  return {
    id: `f_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`,
    url: url.trim(),
    title: null,
    image: null,
    added_at: new Date().toISOString(),
  };
}

export function formatDuration(seconds) {
  if (!seconds || !Number.isFinite(seconds)) return "—";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export function formatPubDate(s) {
  if (!s) return "";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const now = new Date();
  const diffH = (now - d) / (1000 * 60 * 60);
  if (diffH < 24) return "Today";
  if (diffH < 48) return "Yesterday";
  if (diffH < 24 * 7) return `${Math.floor(diffH / 24)} days ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
